import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingImageToVideoConfig } from '@/data/landingConfig/landingImageToVideoConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_ImageToVideo } from './schemaObject';

interface Props {}
const ImageToVideo: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_ImageToVideo} />
			<LandingTemplate
				data={landingImageToVideoConfig}
				funnelLinkService={GenerateLandingLinkService.funnelTextToVideoV2()}
			/>
		</>
	);
};

export default ImageToVideo;
